/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ReportTypeResource = {
    Simple: 'SIMPLE',
    Detailed: 'DETAILED'
} as const;
export type ReportTypeResource = typeof ReportTypeResource[keyof typeof ReportTypeResource];


export function instanceOfReportTypeResource(value: any): boolean {
    for (const key in ReportTypeResource) {
        if (Object.prototype.hasOwnProperty.call(ReportTypeResource, key)) {
            // @ts-ignore
            if (ReportTypeResource[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ReportTypeResourceFromJSON(json: any): ReportTypeResource {
    return ReportTypeResourceFromJSONTyped(json, false);
}

export function ReportTypeResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportTypeResource {
    return json as ReportTypeResource;
}

export function ReportTypeResourceToJSON(value?: ReportTypeResource | null): any {
    return value as any;
}

